import { render, staticRenderFns } from "./FactoryWorker.vue?vue&type=template&id=ecfae63c&scoped=true&"
import script from "./FactoryWorker.vue?vue&type=script&lang=js&"
export * from "./FactoryWorker.vue?vue&type=script&lang=js&"
import style0 from "./FactoryWorker.vue?vue&type=style&index=0&id=ecfae63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfae63c",
  null
  
)

export default component.exports